import React, {useContext, useState} from 'react'
import { useLocation } from 'react-router-dom';

import Hero from '../../components/buyer/Hero';

import { AuthContext } from "../../utils/AuthContext";
import { enqueueSnackbar } from 'notistack';
import Provisions from '../../components/buyer/Provisions';
import ProvisionsFilterTab from '../../components/buyer/ProvisionsFilterTab';

function Home() {

  const { isLogin, login } = useContext(AuthContext);
  const [selectedType, setSelectedType] = useState('All');
  const location = useLocation();

  React.useEffect(()=>{
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token && !isLogin) {
      login(token);
      window.history.replaceState({}, document.title, "/");
      enqueueSnackbar("LoggedIn Successfully!", {variant: "success"})
    }
  }, [location.search, isLogin, login])

  return (
    // <div style={{overflowX: "hidden", position: "relative"}}>
    <div>

      <div className="shadowLeftMid"></div>
      <div className="shadowRightTop"></div>

      <Hero />
      <Provisions selectedType={selectedType} />
      <ProvisionsFilterTab selectedType={selectedType} setSelectedType={setSelectedType} />
      
    </div>
  );
}

export default Home;
